import * as clone from 'clone';

export const deepClone = <T>(obj: T): T => clone(obj);

/**
 * Avoid "can't access property of undefined" errors in a more readable way.
 * @param fn Function that wraps a nested property access
 * @param defaultVal Optional - the value to return if property access failed
 */
export const getSafe = <T>(fn: () => T, defaultVal: T = undefined): T => {
    try {
        return fn();
    } catch (e) {
        return defaultVal;
    }
};
